import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'
import PopModal from '../../../Constant/Custom/Models/PopModal';
import { serverUrl } from '../../../Constant/Static/config';
import { AuthContext } from '../../../Auth/AuthContext';
import { BC, MBC, BCM, SC, SCA, ST, STATES, DISTRICTS } from '../../../Constant/Static/config';
import Loader from '../../../Constant/Custom/Loader';

function Preview({ handleNext, handlePrevious }) {

    const { auth } = useContext(AuthContext);

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
    const [onConfirm, setOnConfirm] = useState(() => () => { });
    const [onCancel, setOnCancel] = useState(() => () => { });
    const [showCancelButton, setShowCancelButton] = useState(false);
    const [decleration, setDecleration] = useState(false)

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const afterSubmission = () => navigate("/dashboard");
    const [photoPreview, setPhotoPreview] = useState('');
    const [signaturePreview, setSignaturePreview] = useState('');
    const storedUser = auth.user;
    const [csrfToken, setCsrfToken] = useState('');

    const [Personal_Info, setPersonal_Info] = useState({
        parentName: '',
        gender: '',
        dob: '',
        citizenship: '',
        nativity: '',
        category: '',
        religion: '',
        community: '',
        caste: '',
        houseAddress: {
            street: '',
            village: '',
            taluk: '',
            district: '',
            pin: '',
        },
        permanentAddress: {
            street: '',
            village: '',
            taluk: '',
            district: '',
            pin: ''
        }
    });

    const [data, setData] = useState([
        { id: 1, study_detail: '', year: '', school: '', district: '', state: '' },
        { id: 2, study_detail: '', year: '', school: '', district: '', state: '' },
        { id: 3, study_detail: '', year: '', school: '', district: '', state: '' },
        { id: 4, study_detail: '', year: '', school: '', district: '', state: '' },
        { id: 5, study_detail: '', year: '', school: '', district: '', state: '' },
    ]);

    const [rows, setRows] = useState([]);
    const [AcademicFormData, setAcademicFormData] = useState({
        lastTN: '',
        courseCategory: '',
        courseType: '',
        mathStudied: '',
        boardStudied: '',
        collegeName: '',
        collegeAddress: '',
        examRegisterNo: '',
        groupName: '',
        branchName: ''
    })

    const [specialForm, setSpecialForm] = useState({
        disability: '',
        sports: '',
        sportsLvl: 0,
        freedomFighter: '',
        exService: '',
        srilankanRefugee: '',
        firstGraduate: ''
    });

    const courseType = new Map([
        ['6', 'Regular'],
        ['4', 'Lateral'],
        ['7', 'Sandwich (7 Semesters)'],
        ['71', 'Sandwich (8 Semesters)'],
        ['72', 'Sandwich (Lateral 7 Semesters)'],
        ['73', 'Sandwich (Lateral 8 Semesters)'],
        ['8', 'Part Time'],
    ])

    // const submitApplication = async () => {
    //     localStorage.removeItem("currentSection");
    //     setShowCancelButton(false)
    //     const res = await axios.post(`${serverUrl}/api/submit-application`, { appno: auth.user.appno });
    //     if (res.status === 200) {
    //         setModalType({
    //             title: "Application Submission",
    //             icon: "success",
    //             text: "Application Submitted Successfully"
    //         })
    //         openModal();
    //         setOnConfirm(() => afterSubmission)
    //     }
    // }

    const handleChange = (e) => {
        setDecleration(e.target.checked)
    }

    const handleSubmit = async () => {
        if (!decleration) {
            setModalType({
                title: "Declaration",
                icon: "warning",
                text: "Kindly accept the decleration"
            })
            openModal();
            setOnConfirm(() => closeModal);
            return;
        }
        // if ((Personal_Info.community === "SC" || Personal_Info.community === "ST" || Personal_Info.community === "SCA")) {
        //     setModalType({
        //         title: "Confirmation",
        //         icon: "info",
        //         text: "Are you sure you want to submit the application? You won't be able to make changes after submission"
        //     })
        //     openModal();
        //     setShowCancelButton(true)
        //     setOnCancel(() => closeModal);
        //     setOnConfirm(() => submitApplication);
        // } else {
            handleNext();
        // }
    }

    const convertCasteCodeToName = (community, code) => {
        // let community = Personal_Info.community;
        // setCommunity(community);
        // let code = Personal_Info.caste;

        // console.log("Comminity | code :", typeof community, code);


        switch (community) {

            case 'OC': {
                setPersonal_Info((prev) => (
                    {
                        ...prev,
                        caste: "Other"
                    }
                ))
                break;
            }

            case 'BC': {
                const caste = BC.find(ele => ele.code === String(code));

                setPersonal_Info((prev) => (
                    {
                        ...prev,
                        caste: caste.name

                    }
                ))
                break;
            }
            case 'BCM': {
                const caste = BCM.find(ele => ele.code === String(code));
                setPersonal_Info((prev) => (
                    {
                        ...prev,
                        caste: caste.name
                    }
                ))
                break;
            }
            case 'MBC': {
                const caste = MBC.find(ele => ele.code === code);
                setPersonal_Info((prev) => (
                    {
                        ...prev,
                        caste: caste.name
                    }
                ))
                break;
            }
            case 'SC': {
                const caste = SC.find(ele => ele.code === String(code));
                // console.log(caste);

                setPersonal_Info((prev) => (
                    {
                        ...prev,
                        caste: caste.name
                    }
                ))
                break;
            }
            case 'SCA': {
                const caste = SCA.find(ele => ele.code === String(code));
                setPersonal_Info((prev) => (
                    {
                        ...prev,
                        caste: caste.name
                    }
                ))
                break;
            }
            case 'ST': {
                const caste = ST.find(ele => ele.code === String(code));
                setPersonal_Info((prev) => (
                    {
                        ...prev,
                        caste: caste.name
                    }
                ))
                break;
            }

            default: {
                setPersonal_Info((prev) => (
                    {
                        ...prev,
                        caste: ""
                    }
                ))
            }
        }



    }


    const setForm = (existingData) => {

        // // console.log(existingData);
        const casteName = convertCasteCodeToName(
            existingData.PersonalPreviewData.community,
            existingData.PersonalPreviewData.caste
        );

        setPersonal_Info({
            ...existingData.PersonalPreviewData,
            caste: casteName, // Store computed caste name
        });
        setData(existingData.StudyDetails);
        setRows(existingData.SemMarks);
        setAcademicFormData(existingData.Academic);
        setSpecialForm(existingData.SpecialData);
        setPhotoPreview(existingData.ImageData.photoUrl);
        setSignaturePreview(existingData.ImageData.signatureUrl);
        convertCasteCodeToName(existingData.PersonalPreviewData.community, existingData.PersonalPreviewData.caste);


    };

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true  // Ensure cookies are sent
                });
                console.log(response);
                setCsrfToken(response.data.csrfToken);  // Set CSRF token
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            localStorage.setItem('currentSection', 6);
            if (csrfToken) {
                try {
                    const userDataFromLocalStorage = auth.user;
                    if (userDataFromLocalStorage) {
                        const response = await axios.post(
                            `${serverUrl}/api/user/preview`,
                            {
                                appno: userDataFromLocalStorage.appno,
                                userName: userDataFromLocalStorage.userName,
                                email: userDataFromLocalStorage.email,
                                mobile: userDataFromLocalStorage.mobile
                            },
                            {
                                headers: {
                                    'CSRF-Token': csrfToken  // Use CSRF token
                                },
                                withCredentials: true
                            }
                        );
                        // // console.log(response.data);
                        if (response.status === 200) {
                            // console.log(response.data);
                            setForm(response.data);
                        } else {
                            // console.log('Error');
                            // setDefaultForm();
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchUserData();
    }, [csrfToken]);

    if (loading) {
        return <Loader />;
    }

    return (
        <section>
            <div className='section-head-container'>
                <h2 className='section-title'>Application Preview</h2>
            </div>
            <div className='preview-container'>
                <div className='candidate-info'>
                    <div className='info-item'>
                        <h4>Application No. &ensp; &ensp;: &ensp;{storedUser?.appno}</h4>
                        <h4>Applicant Name &ensp; :&ensp;{storedUser?.userName}</h4>
                    </div>
                    <div className='info-item'>
                        <h4>Mobile No.&ensp;: &ensp;{storedUser?.mobile} </h4>
                        <h4>Email - ID &ensp;&ensp;: &ensp;{storedUser?.email}</h4>
                    </div>
                    <div className='info-item'>
                        <div className='img-container'>
                            <img src={photoPreview} alt='' width={120} height={120} />
                        </div>
                        <div className='img-container'><img src={signaturePreview} alt='' width={120} height={40} /></div>
                    </div>
                </div>
            </div>
            <div className='preview-personal-info'>
                <h3>Personal Information</h3>
                <div className='preview-personal-info-content'>
                    <div>
                        <ul>
                            <li><b>Name of Parent's/Guardian :</b>{Personal_Info.parentName}</li>
                            <li><b>Gender :</b>{Personal_Info.gender}</li>
                            <li><b>Date of Birth :</b>{new Date(Personal_Info.dob).toLocaleDateString("en-IN", {timeZone: "Asia/Kolkata"})}</li>
                            {Personal_Info.citizenship === 'Indian' &&
                            (<li><b>Aadhaar Number :</b>{Personal_Info.aadhar}</li>)}
                            <li><b>Citizenship :</b>{Personal_Info.citizenship}</li>
                            <li><b>Nativity :</b>{Personal_Info.nativity}</li>
                            {Personal_Info.nativity === 'Others' && <li><b>Category :</b><p>{Personal_Info.category === '1' ? 'Continuously Studied five years in Tamilnadu' : Personal_Info.category === '2' ? 'My parent is Central Government/ State Government/Public sector Employee for past five years continuously in Tamilnadu' : Personal_Info.category === '3' ? 'My parent is serving as All India Tamilnadu Cadre officer' : ''}</p></li>}
                            <li><b>Religion :</b>{Personal_Info.religion === 'H' ? 'Hindu' : Personal_Info.religion === 'M' ? 'Muslim' : Personal_Info.religion === 'C' ? 'Christian' : 'Others'}</li>
                        </ul>
                    </div>
                    <div>
                        <ul>
                            <li><b>Community :</b><p>{Personal_Info.community}</p></li>
                            <li><b>Caste :</b><p>{Personal_Info.caste}</p></li>
                            <li><b>Communication Address :</b><p>{`${Personal_Info.houseAddress.address},${Personal_Info.houseAddress.street},`}<br />{`${Personal_Info.houseAddress.village},${Personal_Info.houseAddress.taluk},${Personal_Info.houseAddress.district},`}<br />{`${Personal_Info.houseAddress.pin}`}</p></li>
                            <li><b>Permanent Address :</b><p>{`${Personal_Info.permanentAddress.address},${Personal_Info.permanentAddress.street},`}<br />{`${Personal_Info.permanentAddress.village},${Personal_Info.permanentAddress.taluk},${Personal_Info.permanentAddress.district},`}<br />{`${Personal_Info.permanentAddress.pin}`}</p></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='preview-special-reserve'>
                <h3>Special Reservation Details</h3>
                <div className='preview-special-reserve-content'>
                    <div>
                        <ul>
                            <li><b>Is Differently Abled Person :</b>{specialForm.disability === 'N' ? 'No' : specialForm.disability === 'Y' ? "Yes" : ''}</li>
                            <li><b>Is Eminent Sports Person :</b>{specialForm.sports === 'N' ? 'No' : specialForm.sports === 'Y' ? 'Yes' : ''}</li>
                            {specialForm.sports === 'Y' && <li><b>Level of Participation :</b>{specialForm.sportsLvl === 1 ? 'International Level' : specialForm.sportsLvl === 2 ? 'National Level' : specialForm.sportsLvl === 3 ? 'State Level' : specialForm.sportsLvl === 4 ? 'Divisional Level' : 'NULL'}</li>}
                            <li><b>Is Children of Freedom Fighter :</b>{specialForm.freedomFighter === 'N' ? 'No' : specialForm.freedomFighter === 'Y' ? 'Yes' : ''}</li>
                        </ul>
                    </div>
                    <div>
                        <ul>
                            <li><b>Is Children of Ex-Service Men :</b>{specialForm.exService === 'N' ? 'No' : specialForm.exService === 'Y' ? 'Yes' : ''}</li>
                            <li><b>Srilankan Tamil Refugee :</b>{specialForm.srilankanRefugee === 'N' ? 'No' : specialForm.srilankanRefugee === 'Y' ? 'Yes' : ''}</li>
                            <li><b>First Graduate :</b>{specialForm.firstGraduate === 'N' ? 'No' : specialForm.firstGraduate === 'Y' ? 'Yes' : ''}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='preview-academic-info'>
                <h3>Academic Information</h3>
                <div className='preview-academic-info-content'>
                    <div className='study-table-container'>
                        <table className='responsive-table'>
                            <caption><b>Last Five Years Study Details : </b></caption>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Study Detail</th>
                                    <th>Year of Passing</th>
                                    <th>School/College Name</th>
                                    <th>District</th>
                                    <th>State</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.study_detail}</td>
                                        <td>{item.year}</td>
                                        <td>{item.school}</td>
                                        <td>{item.district}</td>
                                        <td>{item.state}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className='preview-academic-info-content-container'>
                        <div>
                            <ul>
                                <li><b>Is studied last 5 Years in TN :</b>{AcademicFormData.lastTN === '1' ? 'Yes' : 'No'}</li>
                                <li><b>Course Studied :</b>{AcademicFormData.courseCategory === 'DIP' ? 'Diploma' : AcademicFormData.courseCategory === 'BSC' ? 'B.Sc' : 'NULL'}</li>
                                <li><b>Course Type :</b>{courseType.get(AcademicFormData.courseType)}</li>
                                {AcademicFormData.courseCategory === 'BSC' && <li><b>Is Mathematics studied :</b>{AcademicFormData.mathStudied === 'Y' ? 'Yes' : 'No'}</li>}
                                <li><b>Board of the College :</b>{AcademicFormData.boardStudied}</li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li><b>Name of the Polytechnic/College :</b><p>{AcademicFormData.collegeName}</p></li>
                                {/* <li><b>Address of the Polytechnic/College :</b><p>{AcademicFormData.collegeAddress}</p></li> */}
                                <li><b>Exam Register No :</b>{AcademicFormData.examRegisterNo}</li>
                            </ul>
                        </div>
                    </div>
                    <div className='Instruction'>
                        <strong>Semester Marks</strong>
                    </div>
                    <div className="marks-table-container">
                        <table className="marks-responsive-table">
                            <thead>
                                <tr>
                                    <th>Semester<br /><span>(பருவம்)</span></th>
                                    <th>Month of Passing<br /><span>(தேர்ச்சி பெற்ற மாதம்)</span></th>
                                    <th>Year of Study<br /><span>(தேர்ச்சி பெற்ற வருடம்)</span></th>
                                    <th>Obtained Marks<br /><span>(பெற்ற மதிப்பெண்)</span></th>
                                    <th>Maximum Marks<br /><span>(அதிகபட்ச மதிப்பெண்)</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.semester === 1 ? "1st Semester" : row.semester === 2 ? "2nd Semester" : row.semester === 3 ? "3rd Semester" : row.semester + "th Semester"}</td>
                                        <td>
                                            {row.month}
                                        </td>
                                        <td>
                                            {row.year}
                                        </td>
                                        <td>
                                            {row?.obtainedMarks || 0}
                                        </td>
                                        <td>
                                            {row?.maxMarks || 0}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className='preview-declaration'>
                <h3>Declaration</h3>
                <div className='preview-declaration-content'>
                    <input type="checkbox" style={{ margin: '23px', marginLeft: '20px' }} value={decleration} onChange={handleChange} required />
                    <h5>I, {storedUser.userName} Son/Daughter of {Personal_Info.parentName} hereby solemnly declare that the
                        information furnished in the application and the enclosure are true, correct and complete. I
                        further declare that should it be found otherwise, I will be liable to forfeit my seat and/or remove
                        from the rolls of the Institution at whatever stage of study I may be, besides making me liable for
                        criminal prosecution.</h5>
                </div>
            </div>
            <br />
            <div className='next-button'>
                <button className='log-btn button-secondary' onClick={handlePrevious}>Previous</button>
                {/* <button className='log-btn button-primary' onClick={handleSubmit}> {(Personal_Info.community == "SC" || Personal_Info.community == "ST" || Personal_Info.community == "SCA") ? 'Submit' : 'Proceed to Pay'}</button> */}
                <button className='log-btn button-primary' onClick={handleSubmit}>Proceed to Pay</button> 
            </div>
            <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <PopModal
                    isOpen={isModalOpen}
                    type={modalType}
                    confirmButtonText="OK"
                    onConfirm={onConfirm}
                    showCancelButton={showCancelButton}
                    cancelButtonText="Cancel"
                    onCancel={onCancel}
                />
            </div>

        </section >
    )
}

export default Preview;